import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import MeterView from "../views/MeterView.vue";
import PageNotFound from "../views/NotFound.vue";
import FullImage from "../views/FullImage.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView
    },
    {
        path: "/meter/:id",
        name: "meter",
        component: MeterView,
        meta: {
            isSecure: true
        }
    },
    {
        path: "/image/:MiId/:imageNumber",
        name: "image",
        component: FullImage,
        meta: {
            isSecure: true
        }
    },
    { path: "*", component: PageNotFound }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.isSecure)) {
        if (router.app.$session.exists()) {
            next();
        } else {
            next({
                path: "/",
                query: { redirect: to.fullPath }
            });
        }
    } else {
        next();
    }
});

export default router;
